import { faArrowLeft, faArrowRight, faCircleXmark, faStar } from "@fortawesome/free-solid-svg-icons"
import HomeSearch from "../components/elements/HomeSearch"
import Icon from "../components/Icon"

import Container from "../layout/Container"
import Navbar from "../layout/Navbar"
import PropertyCard from "../components/cards/PropertyCard"

import { useSearchParams } from "react-router-dom"
import { useFetch } from "../hooks/useFetch"
import { allAmenities, allPropertTypes, getHotelByCity } from "../apis"
import { useMemo, useState } from "react"
import useWidth from "../hooks/useWidth"
import MobileHeader from "../layout/MobileHeader"
import MobileHeaderSearch from "../components/MobileHeaderSearch"

export default () => {
    const width = useWidth()
    const searchParams = useSearchParams();

    const city = searchParams[0].get("city") || "Mathura";
    const propertyTypeId = searchParams[0].get("propertyTypeId") || null;
    const search = searchParams[0].get("search") || null;
    const checkIn = searchParams[0].get("checkIn") || null;
    const checkOut = searchParams[0].get("checkOut") || null;
    const room = searchParams[0].get("room") || null ;
    const guest = searchParams[0].get("guest") || null;

    const [ filters, setFilters ] = useState({ 
        cityName: city, 
        amenities: [], 
        propertyTypeId: propertyTypeId, 
        min_price: null, 
        max_price: null, 
        priceRange:null, 
        rating: null,
        search,
        checkIn,
        checkOut,
        room, 
        guest
    })

    const [propertyType] = useFetch(allPropertTypes, [])
    const [amenities] = useFetch(allAmenities, [])
    const [hotelDetails] = useFetch(getHotelByCity, {}, filters)

    const priceRange = useMemo(() => {
        if(hotelDetails?.priceRangeCounts){
            return Object.entries(hotelDetails?.priceRangeCounts)
        }
    }, [hotelDetails])


    return (
        <>
            {
                width > 992 ?
                <Navbar gradient={true} />
                :
                <MobileHeader>
                    <MobileHeaderSearch placeholder="Search Tour& Events" onSearch={ e => setFilters({ ...filters, search: e })} />
                </MobileHeader>

            }
            <Container>
               { width > 992 &&  <section>
                    <div className="mt-5 pt-5">
                        <div className="d-flex justify-content-center flex-column align-items-center ">
                            <h1 className="custom-heading xx-bold">Search Result</h1>
                            <HomeSearch placeholder={"Search Hotels"} onSearch={ e => setFilters({ ...filters, search: e })} />
                        </div>
                    </div>
                </section>}
                <section className="search-section mobile-top-space ">
                    <div className="row">
                        <div className="col-3 p-2">
                            {/* <div className="bg-white  border border-1 p-2" style={{ borderRadius: "16px" }}>
                                <div className="d-flex justify-content-between align-items-center px-4 py-2">
                                    <h5>Filter By: </h5>
                                    <p className="text-saffron">Clear</p>
                                </div>
                                <div className="px-2 d-flex flex-wrap">
                                    <div className="bg-saffron py-1 px-3 d-flex align-items-center justify-content-between m-1" style={{ borderRadius: "20px" }}>
                                        <p className=" m-0 text-white fs-9" >Free Wifi</p>
                                        <Icon icon={faCircleXmark} className="text-white ms-2  fs-9" />
                                    </div>

                                    <div className="bg-saffron py-1 px-3 d-flex align-items-center justify-content-between m-1" style={{ borderRadius: "20px" }}>
                                        <p className=" m-0 text-white fs-9" >Free</p>
                                        <Icon icon={faCircleXmark} className="text-white ms-2 fs-9" />
                                    </div>

                                    <div className="bg-saffron py-1 px-3 d-flex align-items-center justify-content-between m-1" style={{ borderRadius: "20px" }}>
                                        <p className=" m-0 text-white fs-9" >Free Wifi</p>
                                        <Icon icon={faCircleXmark} className="text-white ms-2 fs-9" />
                                    </div>
                                </div>
                                <hr />
                            </div> */}
                            <div className="card mt-4" style={{ borderRadius: "16px" }}>
                                <div className="card-body">
                                    <p className="mb-3 bold">Price Per Night</p>
                                    {
                                        priceRange?.map(([ range, value ], i )=> 
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label htmlFor={range} className="d-flex align-items-center">
                                                    <input type="checkbox" id={range} onChange={(e) =>   setFilters({ ...filters, priceRange: e.target.checked ? range : null }) } checked={ range === filters.priceRange} />
                                                    <p className="ps-2 mb-0">{ range }</p>
                                                </label>
                                                <p>({ value })</p>
                                            </div>
                                        )
                                    }
                                 
                                    <p className="mb-2 mt-3 bold"> Your Budget:</p>
                                    <div className="row d-flex jutify-content-between">
                                        <div className="col-5">
                                            <input className="form-control" placeholder="Min" type="number" onChange={(e) => setFilters({ ...filters, min_price: e.target.value || 0 }) } />
                                        </div>
                                        <div className="col-2">
                                            <p className="text-center mb-0">to</p>
                                        </div>
                                        <div className="col-5">
                                            <input className="form-control" placeholder="Max" type="number" onChange={ e => setFilters({ ...filters, max_price: e.target.value || null })}/>
                                        </div>
                                    </div>

                                    <p className="bold mt-4">
                                        Amenities
                                    </p>
                                    <div>
                                        {
                                            amenities?.map((amenity, i) =>
                                                <label htmlFor={`amenity-${i}`} className="d-flex align-items-center mb-1">
                                                    <input type="checkbox" id={`amenity-${i}`} onChange={(e) => e.target.checked ? setFilters({ ...filters, amenities: [ ...filters.amenities, amenity._id ]}) : setFilters({ ...filters, amenities: filters.amenities?.filter(a => a !== amenity._id )})} />
                                                    <p className="ps-2 mb-0">{ amenity.name }</p>
                                                </label>
                                            )
                                        }
                                    </div>

                                    <p className="bold mt-4">
                                        Property Type
                                    </p>
                                    <div>
                                        {
                                            propertyType?.map((type, i) =>
                                                <label htmlFor={`property-${i}`} className="d-flex align-items-center mb-1">
                                                    <input type="checkbox" id={`property-${i}`} onChange={(e) => e.target.checked ? setFilters({ ...filters, propertyTypeId: type.id }) : setFilters({ ...filters, propertyTypeId: null })} checked={ type.id === filters.propertyTypeId } />
                                                    <p className="ps-2 mb-0">{ type.name }</p>
                                                </label>
                                            )
                                        }
                                    </div>

                                    <p className="bold mt-4">
                                        Star Rating
                                    </p>
                                    <div>
                                        {
                                            [5,4,3,2,1].map( ra => 
                                                <label htmlFor={`rating-${ra}`} className="d-flex align-items-center mb-2">
                                                    <input type="checkbox" id={`rating-${ra}`} onChange={e => setFilters({ ...filters, rating: ra })} />
                                                    {
                                                        Array(ra).fill(0).map( rating =>
                                                            <Icon icon={faStar} className={"text-warning ms-2"} />
                                                        )
                                                    }
                                                </label>
                                            )
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <p className="bold mb-3 custom-text-color" style={{ fontSize: "40px" }}>{city ? city + " : " : "" } { hotelDetails?.count } properties found</p>
                            <div className="row">
                                <div className="col-md-7 col-sm-12">
                                    <p className="custom-text-color">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                </div>
                                <div className="col-md-5 col-sm-12">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <select className="form-control w-50" style={{ borderRadius: "20px" }} onChange={(e) => setFilters({ ...filters, sort: e.target.value  })}>
                                            <option value={"1"}>Sort By: low to high</option>
                                            <option value={"-1"}>Sort By: high to low</option>
                                        </select>

                                        <div className="d-flex justify-content-end">
                                            <div className={` rounded-circle p-3 mx-2 d-flex  align-items-center justify-content-center cursor-pointer ${ hotelDetails.currentPage == 1 ? "bg-primary" : "bg-saffron" }`} style={{ width: "50px", height: "50px" }} onClick={() => hotelDetails.currentPage > 1 && setFilters({ ...filters, page: hotelDetails.currentPage - 1 })}><Icon icon={faArrowLeft} className="text-white" /></div>
                                            <div className={`rounded-circle p-3 mx-2 d-flex  align-items-center justify-content-center cursor-pointer ${ hotelDetails.currentPage == hotelDetails?.totalPages ? "bg-primary": "bg-saffron"}`} style={{ width: "50px", height: "50px" }} onClick={() => hotelDetails.currentPage < hotelDetails.totalPages  && setFilters({ ...filters, page: hotelDetails.currentPage + 1 })}><Icon icon={faArrowRight} className="text-white" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                {
                                    hotelDetails?.hotels?.map((property, i) =>
                                        <div className="col-lg-4 col-md-6 col-sm-12 p-0" key={i}>
                                            <div className=" p-2">
                                                <PropertyCard data={property} imageSlide />
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </Container>
        </>
    )
}